import Icon from '@components/Icon';
import { ReactNode } from 'react';
import * as styles from './index.css';

interface Props {
  children: ReactNode;
  previous?: unknown;
  handlePrevStep: () => void;
}

const StepLayout = ({ children, previous, handlePrevStep }: Props) => (
  <div className={styles.container}>
    {previous ? (
      <button
        type='button'
        className={styles.previous}
        onClick={handlePrevStep}
      >
        <Icon name='arrow_back' size='md' />
        <span className={styles.label}>Retour</span>
      </button>
    ) : (
      <span className={styles.spacer} />
    )}

    <div className={styles.stepWrapper}>{children}</div>
  </div>
);

export default StepLayout;
